// Bilingual content (FR + EN) for Fondation Cœur Solidaire
export const translations = {
  fr: {
    nav: {
      mission: "Notre mission",
      impact: "Notre impact",
      donate: "Faire un don",
      transparency: "Transparence",
      contact: "Contact",
      donateBtn: "Faire un don",
    },
    hero: {
      eyebrow: "Fondation humanitaire internationale",
      title: "Redonner espoir, dignité et avenir aux veuves et aux orphelins, partout dans le monde.",
      subtitle: "Chaque contribution change une vie.",
      tagline: "Un don. Un toit. Un avenir. Une dignité retrouvée.",
      ctaPrimary: "Faire un don maintenant",
      ctaSecondary: "Découvrir notre mission",
      badges: {
        audited: "Comptes audités",
        secure: "Paiement sécurisé PayPal",
        programs: "92 % aux programmes",
      },
    },
    mission: {
      eyebrow: "Notre mission",
      title: "Restaurer la dignité, ouvrir des avenirs.",
      p1: "Depuis 2014, la Fondation Cœur Solidaire accompagne les veuves et les orphelins en situation de grande précarité dans 27 pays. Nous intervenons là où le silence est le plus assourdissant : dans les villages oubliés, les périphéries urbaines, les zones de crise.",
      p2: "Notre engagement est simple et exigeant : offrir un toit, une éducation, des soins, et la possibilité d'une autonomie durable. Nous croyons que la solidarité ne se mesure pas en aumône, mais en avenirs reconstruits.",
      values: [
        { title: "Dignité", desc: "Chaque personne est traitée avec le respect inconditionnel qui lui est dû." },
        { title: "Transparence", desc: "92% des dons financent directement nos programmes sur le terrain." },
        { title: "Durabilité", desc: "Nous accompagnons les familles jusqu'à leur pleine autonomie." },
      ],
    },
    impact: {
      eyebrow: "Notre impact",
      title: "Des vies transformées, en chiffres et en visages.",
      stats: [
        { value: "47 000+", label: "Veuves accompagnées" },
        { value: "112 000+", label: "Orphelins scolarisés" },
        { value: "27", label: "Pays d'intervention" },
        { value: "92%", label: "Affecté aux programmes" },
      ],
      testimonialsTitle: "Témoignages",
      testimonials: [
        {
          quote: "Quand mon mari est parti, je pensais que tout s'éteignait. La fondation m'a appris à coudre, m'a aidée à ouvrir un petit atelier. Aujourd'hui, mes trois enfants sont scolarisés.",
          name: "Aminata, 38 ans",
          location: "Bamako, Mali",
        },
        {
          quote: "J'ai pu reprendre l'école grâce à la bourse. Je veux devenir médecin pour soigner les enfants de mon village.",
          name: "Karim, 14 ans",
          location: "Beyrouth, Liban",
        },
        {
          quote: "Pour la première fois depuis dix ans, j'ai une maison à moi et un avenir pour mes filles.",
          name: "Esther, 42 ans",
          location: "Goma, RDC",
        },
      ],
    },
    donate: {
      eyebrow: "Faire un don",
      title: "Votre générosité, leur renaissance.",
      subtitle: "Chaque euro est utilisé avec rigueur. 92 % vont directement aux programmes de terrain.",
      tabs: { oneTime: "Don ponctuel", monthly: "Don mensuel" },
      amounts: [25, 50, 100, 250],
      customLabel: "Autre montant",
      currency: "€",
      impactLine: (amount) => `Votre don de ${amount} € peut financer ${getImpact(amount, "fr")}.`,
      formName: "Votre nom",
      formEmail: "Votre email",
      formMessage: "Message (optionnel)",
      trustTitle: "Vos données et votre paiement sont protégés",
      trustItems: [
        "Connexion HTTPS chiffrée",
        "Paiement sécurisé via PayPal",
        "Aucune donnée bancaire stockée",
        "Reçu fiscal envoyé par email",
      ],
      legal: "En faisant un don, vous acceptez notre politique de confidentialité.",
      processing: "Traitement en cours...",
      success: "Merci ! Votre don a bien été enregistré.",
      error: "Une erreur est survenue. Réessayez.",
      paypalNotConfigured: "PayPal n'est pas encore configuré. Renseignez PAYPAL_CLIENT_ID et PAYPAL_CLIENT_SECRET dans /app/backend/.env.",
      monthlyNote: "Le don mensuel est traité comme un engagement récurrent. Vous recevrez un email de confirmation.",
      anonymousLabel: "Don anonyme — masquer mon nom dans les listes publiques",
      monthlyButton: "S'engager pour un don mensuel via PayPal",
      monthlyRedirect: "Redirection vers PayPal pour confirmer votre engagement mensuel...",
      stripeButton: "Payer par carte / Apple Pay / Google Pay / SEPA",
      stripeRedirect: "Redirection vers Stripe…",
    },
    transparency: {
      eyebrow: "Transparence",
      title: "Là où va chaque euro.",
      intro: "Notre engagement de transparence est total. Nos comptes sont audités chaque année par un cabinet indépendant et publiés intégralement.",
      breakdown: [
        { label: "Programmes terrain", value: 78, color: "#002B49" },
        { label: "Bourses et soins", value: 14, color: "#C5A059" },
        { label: "Frais de gestion", value: 5, color: "#8C7355" },
        { label: "Collecte de fonds", value: 3, color: "#64748B" },
      ],
      reportLink: "Télécharger le rapport annuel",
    },
    contact: {
      eyebrow: "Contact",
      title: "Parlons-en.",
      subtitle: "Une question, un partenariat, un projet ? Notre équipe vous répond sous 48h.",
      name: "Nom complet",
      email: "Email",
      subject: "Objet",
      message: "Votre message",
      send: "Envoyer le message",
      success: "Merci, votre message a bien été envoyé.",
      error: "Une erreur est survenue. Réessayez.",
      info: {
        emailLabel: "Email",
        emailValue: "contact@coeur-solidaire.org",
        phoneLabel: "Téléphone",
        phoneValue: "+33 1 23 45 67 89",
        addressLabel: "Siège",
        addressValue: "12 rue des Solidarités, 75011 Paris, France",
      },
    },
    footer: {
      tagline: "Un don. Un toit. Un avenir. Une dignité retrouvée.",
      links: {
        about: "À propos",
        legal: "Mentions légales",
        privacy: "Politique de confidentialité",
        cookies: "Cookies",
        admin: "Espace administration",
      },
      copyright: "© 2025 Fondation Cœur Solidaire. Tous droits réservés.",
      registered: "Reconnue d'utilité publique. SIRET 812 345 678 00019.",
      collective: "La Fondation Cœur Solidaire est un programme du collectif Bonheur Solidaire.",
      newsletter: {
        title: "Restons en contact",
        subtitle: "Recevez nos histoires, nos avancées et nos appels au cœur — une fois par mois, sans spam.",
        placeholder: "votre@email.com",
        success: "Merci ! Vous êtes inscrit·e à notre newsletter.",
        alreadySubscribed: "Vous êtes déjà inscrit·e — merci !",
        thanks: "Inscription confirmée. À très vite dans votre boîte !",
        error: "Une erreur est survenue. Réessayez.",
      },
    },
    admin: {
      loginTitle: "Espace administration",
      loginSubtitle: "Connectez-vous pour accéder au tableau de bord.",
      email: "Email",
      password: "Mot de passe",
      login: "Se connecter",
      logout: "Déconnexion",
      backHome: "Retour au site",
      dashboardTitle: "Tableau de bord",
      donationsTab: "Dons reçus",
      messagesTab: "Messages",
      subscriptionsTab: "Souscriptions",
      testimonialsTab: "Témoignages",
      analyticsTab: "Analytics",
      failuresTab: "Échecs paiement",
      settingsTab: "Paramètres",
      noDonations: "Aucun don pour l'instant.",
      noMessages: "Aucun message pour l'instant.",
      totalRaised: "Total collecté",
      totalDonations: "Nombre de dons",
      unreadMessages: "Messages non lus",
      markRead: "Marquer comme lu",
      read: "Lu",
      unread: "Non lu",
      exportCsv: "Exporter en CSV",
      colDate: "Date",
      colDonor: "Donateur",
      colEmail: "Email",
      colAmount: "Montant",
      colType: "Type",
      colPaypal: "PayPal",
      typeMonthly: "Mensuel",
      typeOneTime: "Ponctuel",
      settings: {
        title: "Paramètres généraux",
        subtitle: "Configurez l'objectif mensuel et le seuil de notification admin.",
        goalAmount: "Objectif mensuel",
        goalCurrency: "Devise de l'objectif",
        threshold: "Seuil notification gros don",
        thresholdHelp: "Vous recevrez un email pour chaque don supérieur ou égal à ce montant.",
        save: "Enregistrer",
        reset: "Recharger",
        saved: "Paramètres mis à jour",
      },
      failures: {
        intro: "Donateurs dont le prélèvement automatique a échoué. Relancez-les rapidement avec un email de courtoisie.",
        empty: "Aucun échec de paiement — tout va bien.",
        donor: "Donateur",
        amount: "Montant",
        failed: "Échecs",
        lastReminder: "Dernière relance",
        actions: "Actions",
        never: "Jamais",
        remind: "Relancer par email",
        confirmRemind: "Envoyer un email de relance à {name} ?",
        sent: "Email de relance envoyé",
      },
      usersTab: "Utilisateurs",
      auditTab: "Audit",
      templatesTab: "Templates",
      boardTab: "Conseil d'admin.",
      blogTab: "Actualités",
      impactMapTab: "Carte d'impact",
      campaignsTab: "Campagnes",
      campaigns: {
        title: "Campagnes de collecte",
        subtitle: "Créez des campagnes ciblées avec objectif chiffré et deadline. Les campagnes « mises en avant » apparaissent sur la page d'accueil.",
        addCampaign: "Ajouter une campagne",
        cancel: "Annuler",
        create: "Publier",
        save: "Enregistrer",
        edit: "Modifier",
        delete: "Supprimer",
        empty: "Aucune campagne — créez la première.",
        confirmDelete: "Supprimer définitivement « {title} » ?",
        created: "Campagne créée",
        updated: "Campagne mise à jour",
        deleted: "Campagne supprimée",
        raised: "Collecté",
        goal: "Objectif",
        donors: "donateurs",
        progress: "Progression",
        fTitleFr: "Titre (FR)",
        fTitleEn: "Titre (EN)",
        fDescFr: "Description (FR)",
        fDescEn: "Description (EN)",
        fImage: "URL de la photo (1600×900 idéale)",
        fGoal: "Objectif (montant)",
        fCurrency: "Devise",
        fDeadline: "Date butoir (optionnel)",
        fFeatured: "Mettre en avant sur la home",
        fOrder: "Ordre d'affichage",
        fPublished: "Publié",
        yes: "Oui", no: "Non",
      },
      blog: {
        title: "Actualités / Blog",
        subtitle: "Gérez les articles publiés sur la page publique /actualites.",
        addPost: "Ajouter un article",
        cancel: "Annuler",
        create: "Publier",
        save: "Enregistrer",
        edit: "Modifier",
        delete: "Supprimer",
        empty: "Aucun article — créez le premier.",
        draft: "Brouillon",
        confirmDelete: "Supprimer définitivement « {title} » ?",
        created: "Article publié",
        updated: "Article mis à jour",
        deleted: "Article supprimé",
        fTitleFr: "Titre (FR)",
        fTitleEn: "Titre (EN)",
        fImage: "URL de la photo (1200×680 idéale)",
        fCategory: "Catégorie (terrain, transparence, engagement…)",
        fExcerptFr: "Extrait (FR)",
        fExcerptEn: "Extrait (EN)",
        fContentFr: "Contenu (FR)",
        fContentEn: "Contenu (EN)",
        fPublished: "Publié",
        yes: "Oui", no: "Non",
      },
      impactMap: {
        title: "Carte d'impact — Pays",
        subtitle: "Gérez les pays affichés sur la page publique /carte-impact.",
        addCountry: "Ajouter un pays",
        cancel: "Annuler",
        create: "Créer",
        save: "Enregistrer",
        edit: "Modifier",
        delete: "Supprimer",
        empty: "Aucun pays — ajoutez le premier.",
        draft: "Brouillon",
        confirmDelete: "Supprimer définitivement {name} ?",
        created: "Pays créé",
        updated: "Pays mis à jour",
        deleted: "Pays supprimé",
        widows: "veuves",
        orphans: "orphelins",
        programs: "programmes",
        fNameFr: "Nom du pays (FR)",
        fNameEn: "Nom du pays (EN)",
        fRegion: "Région (Afrique de l'Ouest, Caraïbes…)",
        fFlag: "Emoji drapeau",
        fImage: "URL de la photo (16:9 idéale)",
        fSummaryFr: "Résumé (FR)",
        fSummaryEn: "Résumé (EN)",
        fWidows: "Veuves accompagnées",
        fOrphans: "Orphelins accompagnés",
        fPrograms: "Nombre de programmes",
        fOrder: "Ordre d'affichage",
        fPublished: "Publié",
        yes: "Oui", no: "Non",
      },
      board: {
        title: "Conseil d'administration",
        subtitle: "Gérez les membres affichés sur la page publique /conseil-administration. Les éléments dépubliés ne sont pas visibles.",
        addMember: "Ajouter un membre",
        cancel: "Annuler",
        create: "Créer",
        save: "Enregistrer",
        edit: "Modifier",
        delete: "Supprimer",
        empty: "Aucun membre — ajoutez le premier.",
        confirmDelete: "Supprimer définitivement {name} ?",
        created: "Membre créé",
        updated: "Membre mis à jour",
        deleted: "Membre supprimé",
        fName: "Nom complet",
        fImage: "URL de la photo (carrée, 400x400 idéale)",
        fRoleFr: "Fonction (FR)",
        fRoleEn: "Fonction (EN)",
        fBioFr: "Bio (FR)",
        fBioEn: "Bio (EN)",
        fOrder: "Ordre d'affichage (1 = en premier)",
        fPublished: "Publié",
        yes: "Oui",
        no: "Non",
      },
      users: {
        title: "Utilisateurs administrateurs",
        subtitle: "Gérez les comptes administrateurs et leurs rôles. Seuls les administrateurs peuvent accéder à cet onglet.",
        addUser: "Ajouter un utilisateur",
        cancel: "Annuler",
        create: "Créer",
        edit: "Modifier",
        save: "Enregistrer",
        delete: "Supprimer",
        you: "Vous",
        fEmail: "Email",
        fName: "Nom",
        fPassword: "Mot de passe",
        fRole: "Rôle",
        colEmail: "Email",
        colName: "Nom",
        colRole: "Rôle",
        colCreated: "Créé le",
        colActions: "Actions",
        newPwdPlaceholder: "Nouveau mot de passe (optionnel)",
        confirmDelete: "Supprimer définitivement {email} ?",
        created: "Utilisateur créé",
        updated: "Utilisateur mis à jour",
        deleted: "Utilisateur supprimé",
      },
      audit: {
        title: "Journal d'audit",
        subtitle: "Historique des actions sensibles effectuées dans l'administration.",
        empty: "Aucune entrée pour l'instant.",
        colWhen: "Quand",
        colActor: "Acteur",
        colAction: "Action",
        colTarget: "Cible",
        colDetails: "Détails",
      },
      templates: {
        title: "Template d'email — Relance paiement échoué",
        subtitle: "Personnalisez le sujet et le contenu HTML de l'email envoyé aux donateurs lors d'un échec de prélèvement.",
        fSubject: "Sujet",
        fHtml: "Contenu HTML",
        save: "Enregistrer",
        cancel: "Annuler les modifications",
        preview: "Aperçu",
        hidePreview: "Masquer l'aperçu",
        saved: "Template enregistré",
        reset: "Modifications annulées",
        lastEdit: "Dernière modification",
        varsTitle: "Variables disponibles",
      },
    },
    boardPage: {
      navTitle: "Conseil d'administration",
      back: "Retour à l'accueil",
      eyebrow: "Notre gouvernance",
      title: "Le conseil qui veille sur votre confiance.",
      intro: "Une équipe engagée, expérimentée et bénévole. Ensemble, nous garantissons que chaque don est utilisé avec rigueur, transparence et amour pour celles et ceux que nous accompagnons.",
      badges: {
        audited: "Comptes audités",
        committed: "100% bénévoles",
      },
      loading: "Chargement…",
      empty: "L'équipe se prépare à se présenter — revenez très vite.",
      ctaTitle: "Soutenir notre mission, c'est faire confiance à cette équipe.",
      ctaSubtitle: "Chaque don, même modeste, est traité avec la même rigueur que les engagements à six chiffres.",
      ctaButton: "Faire un don maintenant",
    },
    testimonialsPage: {
      title: "Voix de celles et ceux que nous accompagnons",
      eyebrow: "Témoignages",
      intro: "Des récits réels de veuves et d'orphelins dont la vie a basculé grâce à votre solidarité. Filtrez par pays pour découvrir l'impact dans une région précise.",
      filterAll: "Tous les pays",
      countCount: (n) => `${n} témoignage${n > 1 ? "s" : ""}`,
      empty: "Aucun témoignage publié pour cet instant.",
      ctaTitle: "Vous aussi, écrivez la prochaine histoire.",
      ctaSubtitle: "Chaque don construit un nouveau chapitre.",
      ctaButton: "Faire un don maintenant",
      backHome: "Retour à l'accueil",
      seoTitle: "Témoignages – Fondation Cœur Solidaire",
      seoDescription: "Découvrez les histoires réelles des veuves et orphelins accompagnés par la Fondation Cœur Solidaire dans 27 pays. Mali, Liban, RDC et bien d'autres.",
    },
    blogPage: {
      back: "Retour à l'accueil",
      eyebrow: "Actualités & coulisses",
      title: "Sur le terrain : nouvelles, avancées et appels au cœur.",
      intro: "Plongez dans la vie des programmes, les histoires de bénéficiaires, et les annonces de la fondation. Une fenêtre transparente sur ce que votre solidarité rend possible.",
      loading: "Chargement…",
      empty: "Aucun article publié pour l'instant.",
      readMore: "Lire l'article",
      notFound: "Cet article est introuvable.",
      allArticles: "Tous les articles",
      ctaDonate: "Soutenir cette mission",
    },
    impactMapPage: {
      back: "Retour à l'accueil",
      eyebrow: "Notre présence dans le monde",
      title: "Là où votre générosité change des vies.",
      intro: "Découvrez nos programmes pays par pays. Chaque région est unique : nos équipes locales adaptent l'aide aux besoins réels du terrain.",
      kpis: {
        countries: "Pays d'intervention",
        widows: "Veuves accompagnées",
        orphans: "Orphelins scolarisés",
      },
      stats: {
        widows: "Veuves",
        orphans: "Orphelins",
        programs: "Programmes",
      },
      loading: "Chargement…",
      empty: "Aucun pays publié pour l'instant.",
      ctaTitle: "Et demain, dans dix nouveaux pays.",
      ctaSubtitle: "Votre don finance directement l'extension de nos programmes vers les zones les plus oubliées.",
      ctaButton: "Faire un don maintenant",
    },
    legacyPage: {
      back: "Retour à l'accueil",
      eyebrow: "Faire un legs",
      title: "Transmettre un héritage de solidarité.",
      intro: "Le legs, la donation ou l'assurance-vie sont des actes profondément humains. Ils prolongent votre engagement bien au-delà d'une vie.",
      options: [
        { title: "Le legs testamentaire", desc: "Inscrivez la fondation dans votre testament. Tout legs en faveur d'une fondation reconnue d'utilité publique est totalement exonéré de droits de succession." },
        { title: "La donation entre vifs", desc: "Vous pouvez transmettre dès maintenant un bien (immobilier, mobilier, parts sociales). Réduction d'impôt jusqu'à 75 % du montant donné." },
        { title: "Le don en nature", desc: "Œuvres d'art, véhicules, outillage, mobilier de bureau : tout bien valorisable peut nous aider concrètement sur le terrain." },
      ],
      trustTitle: "Un accompagnement notarial confidentiel",
      trustText: "Notre référent legs travaille en lien étroit avec votre notaire et garantit la confidentialité totale de vos démarches.",
      formTitle: "Parlons de votre projet",
      formSubtitle: "Notre référent legs vous recontacte sous 48h, en toute confidentialité.",
      defaultSubject: "Demande d'information — legs ou donation",
      form: {
        name: "Nom complet",
        email: "Email",
        subject: "Objet",
        message: "Votre demande",
        send: "Envoyer ma demande",
        success: "Merci, votre demande a bien été reçue.",
        successSubtitle: "Notre référent legs vous recontacte sous 48h, en toute confidentialité.",
        sendAnother: "Envoyer une autre demande",
        error: "Une erreur est survenue. Réessayez.",
      },
    },
    volunteerPage: {
      back: "Retour à l'accueil",
      eyebrow: "Rejoindre la fondation",
      title: "Vos talents, notre force collective.",
      intro: "Bénévoles passionné·es ou organisations partenaires : votre engagement démultiplie notre impact sur le terrain.",
      tabs: {
        volunteer: "Devenir bénévole",
        partner: "Devenir partenaire",
      },
      volunteer: {
        heading: "Donner de votre temps",
        description: "Mentorat, traduction, missions terrain : nos bénévoles font la différence chaque jour. Tous les profils sont bienvenus.",
        items: [
          { tag: "À distance", title: "Mentor·e bourse universitaire", desc: "2h par semaine pour accompagner un·e étudiant·e bénéficiaire d'une bourse." },
          { tag: "À distance", title: "Traducteur·rice FR ↔ EN", desc: "Lettre d'information mensuelle, articles de blog, témoignages." },
          { tag: "Terrain", title: "Coordinateur·rice mission Sénégal", desc: "Mission de 3 mois, indemnités prévues. Profil expérimenté en gestion de projet." },
        ],
        formTitle: "Candidater comme bénévole",
        formSubtitle: "Décrivez vos compétences et disponibilités. Nous revenons vers vous sous 7 jours.",
        defaultSubject: "Candidature bénévole",
        form: {
          name: "Nom complet",
          email: "Email",
          subject: "Mission souhaitée",
          message: "Compétences, disponibilités, motivation",
          send: "Envoyer ma candidature",
          success: "Merci ! Votre candidature est bien reçue.",
          successSubtitle: "Notre équipe revient vers vous sous 7 jours.",
          sendAnother: "Envoyer une autre candidature",
          error: "Une erreur est survenue. Réessayez.",
        },
      },
      partner: {
        heading: "Construire ensemble",
        description: "Entreprises, fondations, ONG, collectivités : devenez partenaire stratégique de nos programmes terrain.",
        items: [
          { tag: "Entreprise", title: "Mécénat financier", desc: "Soutien d'un programme pays sur 1 à 3 ans, plan de communication conjoint." },
          { tag: "ONG", title: "Co-construction terrain", desc: "Mutualisation de ressources et d'expertises sur des missions humanitaires." },
          { tag: "Public", title: "Convention multipartite", desc: "Collectivités françaises ou étrangères : accord-cadre pour des actions ciblées." },
        ],
        formTitle: "Discuter d'un partenariat",
        formSubtitle: "Notre équipe partenariats vous recontacte sous 5 jours ouvrés.",
        defaultSubject: "Demande de partenariat",
        form: {
          name: "Nom du contact",
          email: "Email professionnel",
          subject: "Type de partenariat envisagé",
          message: "Présentation de votre structure et de votre projet",
          send: "Envoyer ma demande",
          success: "Merci, votre demande est bien reçue.",
          successSubtitle: "Notre équipe partenariats revient vers vous sous 5 jours.",
          sendAnother: "Envoyer une autre demande",
          error: "Une erreur est survenue. Réessayez.",
        },
      },
    },
    donorPortal: {
      back: "Retour à l'accueil",
      eyebrow: "Espace donateur",
      title: "Votre engagement, votre tableau de bord.",
      intro: "Saisissez votre email pour recevoir un lien de connexion sécurisé. Vous accéderez à l'historique de vos dons et pourrez gérer votre engagement mensuel.",
      welcome: "Bienvenue,",
      formTitle: "Recevoir un lien de connexion",
      formSubtitle: "Nous vous envoyons un lien sécurisé valable 30 minutes — pas besoin de mot de passe.",
      emailPlaceholder: "votre@email.com",
      sendLink: "Recevoir mon lien",
      privacyNote: "Pour votre sécurité, nous ne révélons jamais si une adresse correspond à un compte donateur.",
      linkSent: "Si l'adresse est connue, un lien vient d'être envoyé.",
      linkSentTitle: "Vérifiez votre boîte email",
      linkSentText: "Si cette adresse est associée à un don, vous y trouverez un lien sécurisé valide 30 minutes.",
      tryAnother: "Utiliser une autre adresse",
      error: "Une erreur est survenue. Réessayez.",
      connectedAs: "Connecté·e en tant que",
      logout: "Déconnexion",
      kpis: {
        total: "Total donné",
        count: "Dons effectués",
        activeSub: "Engagement mensuel",
      },
      activeSubTitle: "Vous avez un don mensuel actif",
      activeSubText: "Merci pour votre engagement durable. Vous pouvez l'annuler à tout moment, sans justification.",
      cancelSub: "Annuler mon don mensuel",
      confirmCancel: "Confirmer l'annulation de votre don mensuel ?",
      cancelled: "Don mensuel annulé. Merci pour tout ce que vous avez offert.",
      historyTitle: "Historique de vos dons",
      empty: "Aucun don pour l'instant.",
      cols: {
        date: "Date",
        amount: "Montant",
        type: "Type",
        status: "Statut",
        actions: "Reçu",
      },
      monthly: "Mensuel",
      oneTime: "Ponctuel",
      downloadReceipt: "Télécharger le reçu",
    },
    seo: {
      home: {
        title: "Fondation Cœur Solidaire — Veuves & orphelins, dignité retrouvée",
        description: "Fondation humanitaire internationale. Depuis 2014, nous redonnons espoir, dignité et avenir aux veuves et orphelins dans 27 pays. Faites un don sécurisé — 92 % aux programmes terrain.",
      },
      campaigns: {
        title: "Nos campagnes de collecte",
        description: "Soutenez une campagne ciblée : rentrée scolaire, urgence Liban, Toit & Avenir au Mali. Chaque don finance un objectif précis, vérifié et audité.",
      },
      blog: {
        title: "Actualités & coulisses",
        description: "Sur le terrain : nouvelles, avancées et appels au cœur de la Fondation Cœur Solidaire. Une fenêtre transparente sur ce que votre solidarité rend possible.",
      },
      impactMap: {
        title: "Notre présence dans le monde",
        description: "27 pays, 47 000 veuves et 112 000 orphelins accompagnés. Découvrez nos programmes pays par pays.",
      },
      board: {
        title: "Conseil d'administration",
        description: "Une équipe engagée, expérimentée et 100 % bénévole qui garantit la rigueur de chaque euro.",
      },
      testimonials: {
        title: "Voix de celles et ceux que nous accompagnons",
        description: "Découvrez les histoires réelles des veuves et orphelins accompagnés par la Fondation Cœur Solidaire dans 27 pays.",
      },
      legacy: {
        title: "Faire un legs ou une donation",
        description: "Transmettez un héritage de solidarité. Legs testamentaire, donation entre vifs, dons en nature — accompagnement notarial confidentiel.",
      },
      volunteer: {
        title: "Devenir bénévole ou partenaire",
        description: "Rejoignez la fondation. Bénévoles, mentors, entreprises, ONG : votre engagement démultiplie notre impact terrain.",
      },
    },
    campaignsPage: {
      back: "Retour à l'accueil",
      eyebrow: "Campagnes en cours",
      title: "Choisissez la cause qui vous touche.",
      intro: "Chaque campagne finance un objectif concret et vérifié sur le terrain. Suivez la progression en direct, donnez en quelques secondes.",
      loading: "Chargement…",
      empty: "Aucune campagne en cours. Revenez très vite.",
      raised: "collectés",
      of: "sur",
      donors: "donateurs",
      deadline: "Fin",
      noDeadline: "Continue",
      progress: "Progression",
      support: "Soutenir cette campagne",
      moreDetails: "En savoir plus",
      completed: "Objectif atteint",
      remaining: "restant",
      ctaTitle: "Une autre cause vous appelle ?",
      ctaSubtitle: "Faites un don libre, nous l'affecterons là où l'urgence est la plus forte.",
      ctaButton: "Faire un don libre",
      navLink: "Campagnes",
    },
    campaignDetail: {
      back: "Toutes les campagnes",
      raised: "collectés",
      goal: "Objectif",
      donors: "donateurs",
      deadline: "Date butoir",
      noDeadline: "Continue",
      supportNow: "Soutenir cette campagne",
      shareTitle: "Partagez cette campagne",
      shareTwitter: "Partager sur X",
      shareWhatsapp: "Partager sur WhatsApp",
      shareLinkedin: "Partager sur LinkedIn",
      shareCopy: "Copier le lien",
      copied: "Lien copié",
      notFound: "Cette campagne est introuvable.",
      relatedTitle: "Autres campagnes",
    },
    homeCampaigns: {
      eyebrow: "Campagnes en cours",
      title: "Soutenez une cause précise.",
      subtitle: "Chaque campagne finance un objectif concret. Suivez la progression en direct.",
      viewAll: "Voir toutes les campagnes",
      raised: "collectés",
      of: "sur",
      support: "Soutenir",
    },
  },
  en: {
    nav: {
      mission: "Our mission",
      impact: "Our impact",
      donate: "Donate",
      transparency: "Transparency",
      contact: "Contact",
      donateBtn: "Donate",
    },
    hero: {
      eyebrow: "International humanitarian foundation",
      title: "Restoring hope, dignity and a future to widows and orphans, around the world.",
      subtitle: "Every contribution changes a life.",
      tagline: "A gift. A roof. A future. A dignity restored.",
      ctaPrimary: "Donate now",
      ctaSecondary: "Discover our mission",
      badges: {
        audited: "Audited accounts",
        secure: "Secure PayPal checkout",
        programs: "92% to programs",
      },
    },
    mission: {
      eyebrow: "Our mission",
      title: "Restoring dignity, opening futures.",
      p1: "Since 2014, Fondation Cœur Solidaire has stood beside widows and orphans living in extreme hardship across 27 countries. We act where silence is loudest: forgotten villages, urban edges, conflict zones.",
      p2: "Our commitment is simple and demanding: provide shelter, education, healthcare, and the path to lasting autonomy. Solidarity is not measured in alms, but in futures rebuilt.",
      values: [
        { title: "Dignity", desc: "Every person is treated with the unconditional respect they deserve." },
        { title: "Transparency", desc: "92% of donations directly fund our field programs." },
        { title: "Sustainability", desc: "We walk with families until they reach full autonomy." },
      ],
    },
    impact: {
      eyebrow: "Our impact",
      title: "Lives transformed, in numbers and faces.",
      stats: [
        { value: "47,000+", label: "Widows supported" },
        { value: "112,000+", label: "Orphans in school" },
        { value: "27", label: "Countries of action" },
        { value: "92%", label: "Spent on programs" },
      ],
      testimonialsTitle: "Voices we serve",
      testimonials: [
        {
          quote: "When my husband passed, I thought everything was over. The foundation taught me to sew and helped me open a small workshop. Today my three children are in school.",
          name: "Aminata, 38",
          location: "Bamako, Mali",
        },
        {
          quote: "I was able to go back to school thanks to the scholarship. I want to become a doctor to heal the children of my village.",
          name: "Karim, 14",
          location: "Beirut, Lebanon",
        },
        {
          quote: "For the first time in ten years, I have a home of my own and a future for my daughters.",
          name: "Esther, 42",
          location: "Goma, DRC",
        },
      ],
    },
    donate: {
      eyebrow: "Donate",
      title: "Your generosity, their rebirth.",
      subtitle: "Every euro is used with rigor. 92% goes directly to field programs.",
      tabs: { oneTime: "One-time", monthly: "Monthly" },
      amounts: [25, 50, 100, 250],
      customLabel: "Other amount",
      currency: "€",
      impactLine: (amount) => `Your gift of €${amount} can fund ${getImpact(amount, "en")}.`,
      formName: "Your name",
      formEmail: "Your email",
      formMessage: "Message (optional)",
      trustTitle: "Your data and payment are protected",
      trustItems: [
        "Encrypted HTTPS connection",
        "Secure payment via PayPal",
        "No banking data stored",
        "Tax receipt sent by email",
      ],
      legal: "By donating, you accept our privacy policy.",
      processing: "Processing...",
      success: "Thank you! Your donation has been recorded.",
      error: "Something went wrong. Please retry.",
      paypalNotConfigured: "PayPal is not yet configured. Set PAYPAL_CLIENT_ID and PAYPAL_CLIENT_SECRET in /app/backend/.env.",
      monthlyNote: "Monthly giving is treated as a recurring commitment. You will receive a confirmation email.",
      anonymousLabel: "Anonymous donation — hide my name from public lists",
      monthlyButton: "Commit to monthly giving via PayPal",
      monthlyRedirect: "Redirecting to PayPal to confirm your monthly commitment...",
      stripeButton: "Pay by card / Apple Pay / Google Pay / SEPA",
      stripeRedirect: "Redirecting to Stripe…",
    },
    transparency: {
      eyebrow: "Transparency",
      title: "Where every euro goes.",
      intro: "Our commitment to transparency is total. Our accounts are audited yearly by an independent firm and published in full.",
      breakdown: [
        { label: "Field programs", value: 78, color: "#002B49" },
        { label: "Scholarships & care", value: 14, color: "#C5A059" },
        { label: "Operations", value: 5, color: "#8C7355" },
        { label: "Fundraising", value: 3, color: "#64748B" },
      ],
      reportLink: "Download the annual report",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk.",
      subtitle: "A question, a partnership, a project? Our team replies within 48 hours.",
      name: "Full name",
      email: "Email",
      subject: "Subject",
      message: "Your message",
      send: "Send message",
      success: "Thank you, your message has been sent.",
      error: "Something went wrong. Please retry.",
      info: {
        emailLabel: "Email",
        emailValue: "contact@coeur-solidaire.org",
        phoneLabel: "Phone",
        phoneValue: "+33 1 23 45 67 89",
        addressLabel: "Headquarters",
        addressValue: "12 rue des Solidarités, 75011 Paris, France",
      },
    },
    footer: {
      tagline: "A gift. A roof. A future. A dignity restored.",
      links: {
        about: "About",
        legal: "Legal notice",
        privacy: "Privacy policy",
        cookies: "Cookies",
        admin: "Admin login",
      },
      copyright: "© 2025 Fondation Cœur Solidaire. All rights reserved.",
      registered: "Recognized as a public-interest foundation. SIRET 812 345 678 00019.",
      collective: "The Fondation Cœur Solidaire is a program of the Bonheur Solidaire collective.",
      newsletter: {
        title: "Stay in touch",
        subtitle: "Receive our stories, milestones and heartfelt updates — once a month, no spam.",
        placeholder: "your@email.com",
        success: "Thank you! You're now subscribed.",
        alreadySubscribed: "You're already subscribed — thank you!",
        thanks: "Subscription confirmed. See you in your inbox!",
        error: "Something went wrong. Please try again.",
      },
    },
    admin: {
      loginTitle: "Admin space",
      loginSubtitle: "Sign in to access the dashboard.",
      email: "Email",
      password: "Password",
      login: "Sign in",
      logout: "Sign out",
      backHome: "Back to site",
      dashboardTitle: "Dashboard",
      donationsTab: "Donations",
      messagesTab: "Messages",
      subscriptionsTab: "Subscriptions",
      testimonialsTab: "Testimonials",
      analyticsTab: "Analytics",
      failuresTab: "Payment failures",
      settingsTab: "Settings",
      noDonations: "No donations yet.",
      noMessages: "No messages yet.",
      totalRaised: "Total raised",
      totalDonations: "Total donations",
      unreadMessages: "Unread messages",
      markRead: "Mark as read",
      read: "Read",
      unread: "Unread",
      exportCsv: "Export as CSV",
      colDate: "Date",
      colDonor: "Donor",
      colEmail: "Email",
      colAmount: "Amount",
      colType: "Type",
      colPaypal: "PayPal",
      typeMonthly: "Monthly",
      typeOneTime: "One-time",
      settings: {
        title: "General settings",
        subtitle: "Configure the monthly goal and admin notification threshold.",
        goalAmount: "Monthly goal",
        goalCurrency: "Goal currency",
        threshold: "Large-donation alert threshold",
        thresholdHelp: "You will receive an email for every donation greater than or equal to this amount.",
        save: "Save",
        reset: "Reload",
        saved: "Settings updated",
      },
      failures: {
        intro: "Donors whose automatic payment failed. Reach out promptly with a friendly reminder email.",
        empty: "No payment failures — all clear.",
        donor: "Donor",
        amount: "Amount",
        failed: "Failed",
        lastReminder: "Last reminder",
        actions: "Actions",
        never: "Never",
        remind: "Send reminder",
        confirmRemind: "Send a reminder email to {name}?",
        sent: "Reminder sent",
      },
      usersTab: "Users",
      auditTab: "Audit",
      templatesTab: "Templates",
      boardTab: "Board",
      blogTab: "Blog",
      impactMapTab: "Impact map",
      campaignsTab: "Campaigns",
      campaigns: {
        title: "Fundraising campaigns",
        subtitle: "Create targeted campaigns with a numeric goal and deadline. \"Featured\" campaigns appear on the homepage.",
        addCampaign: "Add campaign",
        cancel: "Cancel",
        create: "Publish",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        empty: "No campaigns — create the first one.",
        confirmDelete: "Permanently delete \"{title}\"?",
        created: "Campaign created",
        updated: "Campaign updated",
        deleted: "Campaign deleted",
        raised: "Raised",
        goal: "Goal",
        donors: "donors",
        progress: "Progress",
        fTitleFr: "Title (FR)",
        fTitleEn: "Title (EN)",
        fDescFr: "Description (FR)",
        fDescEn: "Description (EN)",
        fImage: "Photo URL (1600×900 ideal)",
        fGoal: "Goal amount",
        fCurrency: "Currency",
        fDeadline: "Deadline (optional)",
        fFeatured: "Feature on homepage",
        fOrder: "Display order",
        fPublished: "Published",
        yes: "Yes", no: "No",
      },
      blog: {
        title: "News / Blog",
        subtitle: "Manage articles published on the public /actualites page.",
        addPost: "Add post",
        cancel: "Cancel",
        create: "Publish",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        empty: "No articles — create the first one.",
        draft: "Draft",
        confirmDelete: "Permanently delete \"{title}\"?",
        created: "Article published",
        updated: "Article updated",
        deleted: "Article deleted",
        fTitleFr: "Title (FR)",
        fTitleEn: "Title (EN)",
        fImage: "Photo URL (1200×680 ideal)",
        fCategory: "Category (field, transparency, engagement…)",
        fExcerptFr: "Excerpt (FR)",
        fExcerptEn: "Excerpt (EN)",
        fContentFr: "Content (FR)",
        fContentEn: "Content (EN)",
        fPublished: "Published",
        yes: "Yes", no: "No",
      },
      impactMap: {
        title: "Impact map — Countries",
        subtitle: "Manage countries displayed on the public /carte-impact page.",
        addCountry: "Add country",
        cancel: "Cancel",
        create: "Create",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        empty: "No country — add the first one.",
        draft: "Draft",
        confirmDelete: "Permanently delete {name}?",
        created: "Country created",
        updated: "Country updated",
        deleted: "Country deleted",
        widows: "widows",
        orphans: "orphans",
        programs: "programs",
        fNameFr: "Country name (FR)",
        fNameEn: "Country name (EN)",
        fRegion: "Region (West Africa, Caribbean…)",
        fFlag: "Flag emoji",
        fImage: "Photo URL (16:9 ideal)",
        fSummaryFr: "Summary (FR)",
        fSummaryEn: "Summary (EN)",
        fWidows: "Widows supported",
        fOrphans: "Orphans supported",
        fPrograms: "Number of programs",
        fOrder: "Display order",
        fPublished: "Published",
        yes: "Yes", no: "No",
      },
      board: {
        title: "Board of Directors",
        subtitle: "Manage members shown on the public /conseil-administration page. Unpublished items are hidden.",
        addMember: "Add member",
        cancel: "Cancel",
        create: "Create",
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        empty: "No member — add the first one.",
        confirmDelete: "Permanently delete {name}?",
        created: "Member created",
        updated: "Member updated",
        deleted: "Member deleted",
        fName: "Full name",
        fImage: "Photo URL (square, 400x400 ideal)",
        fRoleFr: "Role (FR)",
        fRoleEn: "Role (EN)",
        fBioFr: "Bio (FR)",
        fBioEn: "Bio (EN)",
        fOrder: "Display order (1 = first)",
        fPublished: "Published",
        yes: "Yes",
        no: "No",
      },
      users: {
        title: "Admin users",
        subtitle: "Manage administrator accounts and their roles. Only admins can access this tab.",
        addUser: "Add user",
        cancel: "Cancel",
        create: "Create",
        edit: "Edit",
        save: "Save",
        delete: "Delete",
        you: "You",
        fEmail: "Email",
        fName: "Name",
        fPassword: "Password",
        fRole: "Role",
        colEmail: "Email",
        colName: "Name",
        colRole: "Role",
        colCreated: "Created",
        colActions: "Actions",
        newPwdPlaceholder: "New password (optional)",
        confirmDelete: "Permanently delete {email}?",
        created: "User created",
        updated: "User updated",
        deleted: "User deleted",
      },
      audit: {
        title: "Audit log",
        subtitle: "History of sensitive actions performed in the admin panel.",
        empty: "No entries yet.",
        colWhen: "When",
        colActor: "Actor",
        colAction: "Action",
        colTarget: "Target",
        colDetails: "Details",
      },
      templates: {
        title: "Email template — Failed-payment reminder",
        subtitle: "Customize the subject and HTML body of the reminder email sent to donors after a failed charge.",
        fSubject: "Subject",
        fHtml: "HTML body",
        save: "Save",
        cancel: "Discard changes",
        preview: "Preview",
        hidePreview: "Hide preview",
        saved: "Template saved",
        reset: "Changes discarded",
        lastEdit: "Last edit",
        varsTitle: "Available variables",
      },
    },
    boardPage: {
      navTitle: "Board of Directors",
      back: "Back to homepage",
      eyebrow: "Our Governance",
      title: "The board that safeguards your trust.",
      intro: "A committed, experienced and volunteer-only team. Together we guarantee that every donation is used with rigor, transparency and care for those we support.",
      badges: {
        audited: "Audited accounts",
        committed: "100% volunteer",
      },
      loading: "Loading…",
      empty: "The team is preparing to introduce themselves — come back soon.",
      ctaTitle: "Supporting our mission means trusting this team.",
      ctaSubtitle: "Every donation, however modest, is treated with the same rigor as six-figure commitments.",
      ctaButton: "Donate now",
    },
    testimonialsPage: {
      title: "Voices of those we walk beside",
      eyebrow: "Testimonials",
      intro: "Real stories of widows and orphans whose lives have changed thanks to your solidarity. Filter by country to discover impact in a specific region.",
      filterAll: "All countries",
      countCount: (n) => `${n} story${n > 1 ? "ies" : ""}`,
      empty: "No published testimonial yet.",
      ctaTitle: "Write the next story with us.",
      ctaSubtitle: "Every gift builds a new chapter.",
      ctaButton: "Donate now",
      backHome: "Back to home",
      seoTitle: "Testimonials – Fondation Cœur Solidaire",
      seoDescription: "Discover the real stories of widows and orphans walking with Fondation Cœur Solidaire across 27 countries — Mali, Lebanon, DRC and many more.",
    },
    blogPage: {
      back: "Back to home",
      eyebrow: "News & field stories",
      title: "From the field: news, milestones and heartfelt updates.",
      intro: "Step inside our programs, hear beneficiary stories, and follow our announcements. A transparent window on what your solidarity makes possible.",
      loading: "Loading…",
      empty: "No articles yet.",
      readMore: "Read article",
      notFound: "This article cannot be found.",
      allArticles: "All articles",
      ctaDonate: "Support this mission",
    },
    impactMapPage: {
      back: "Back to home",
      eyebrow: "Our presence around the world",
      title: "Where your generosity changes lives.",
      intro: "Discover our programs country by country. Each region is unique: our local teams adapt aid to real field needs.",
      kpis: {
        countries: "Countries of action",
        widows: "Widows supported",
        orphans: "Orphans in school",
      },
      stats: {
        widows: "Widows",
        orphans: "Orphans",
        programs: "Programs",
      },
      loading: "Loading…",
      empty: "No country published yet.",
      ctaTitle: "Tomorrow, ten new countries.",
      ctaSubtitle: "Your gift directly funds the expansion of our programs to the most forgotten regions.",
      ctaButton: "Donate now",
    },
    legacyPage: {
      back: "Back to home",
      eyebrow: "Leave a legacy",
      title: "Pass on a legacy of solidarity.",
      intro: "A bequest, a donation or a life-insurance gift are deeply human acts. They extend your commitment far beyond a lifetime.",
      options: [
        { title: "Bequest in your will", desc: "Include the foundation in your will. Any bequest to a public-interest foundation is fully exempt from inheritance taxes." },
        { title: "Lifetime donation", desc: "You can transfer assets (real estate, securities, valuables) right now. Tax reduction up to 75% of the amount given." },
        { title: "In-kind donation", desc: "Artwork, vehicles, equipment, office furniture: any valuable asset can concretely help us on the field." },
      ],
      trustTitle: "Confidential notarial support",
      trustText: "Our legacy officer works closely with your notary and guarantees full confidentiality throughout your steps.",
      formTitle: "Let's discuss your project",
      formSubtitle: "Our legacy officer will contact you within 48 hours, in full confidence.",
      defaultSubject: "Information request — bequest or donation",
      form: {
        name: "Full name",
        email: "Email",
        subject: "Subject",
        message: "Your request",
        send: "Send my request",
        success: "Thank you, your request has been received.",
        successSubtitle: "Our legacy officer will contact you within 48 hours, in full confidence.",
        sendAnother: "Send another request",
        error: "Something went wrong. Please retry.",
      },
    },
    volunteerPage: {
      back: "Back to home",
      eyebrow: "Join the foundation",
      title: "Your talents, our collective strength.",
      intro: "Passionate volunteers or partner organizations: your commitment multiplies our field impact.",
      tabs: {
        volunteer: "Become a volunteer",
        partner: "Become a partner",
      },
      volunteer: {
        heading: "Give your time",
        description: "Mentoring, translation, field missions: our volunteers make a difference every day. All profiles are welcome.",
        items: [
          { tag: "Remote", title: "Scholarship mentor", desc: "2 hours per week to accompany a scholarship-holding student." },
          { tag: "Remote", title: "Translator FR ↔ EN", desc: "Monthly newsletter, blog posts, testimonials." },
          { tag: "Field", title: "Senegal mission coordinator", desc: "3-month mission, stipend provided. Experienced project-management profile." },
        ],
        formTitle: "Apply as a volunteer",
        formSubtitle: "Describe your skills and availability. We will get back to you within 7 days.",
        defaultSubject: "Volunteer application",
        form: {
          name: "Full name",
          email: "Email",
          subject: "Mission of interest",
          message: "Skills, availability, motivation",
          send: "Send my application",
          success: "Thank you! Your application has been received.",
          successSubtitle: "Our team will get back to you within 7 days.",
          sendAnother: "Send another application",
          error: "Something went wrong. Please retry.",
        },
      },
      partner: {
        heading: "Build together",
        description: "Companies, foundations, NGOs, public bodies: become a strategic partner of our field programs.",
        items: [
          { tag: "Company", title: "Corporate philanthropy", desc: "Support a country program over 1 to 3 years, joint communication plan." },
          { tag: "NGO", title: "Field co-construction", desc: "Pooling of resources and expertise on humanitarian missions." },
          { tag: "Public", title: "Multi-party agreement", desc: "French or foreign public bodies: framework agreement for targeted actions." },
        ],
        formTitle: "Discuss a partnership",
        formSubtitle: "Our partnerships team will contact you within 5 working days.",
        defaultSubject: "Partnership request",
        form: {
          name: "Contact name",
          email: "Professional email",
          subject: "Type of partnership",
          message: "Presentation of your organization and project",
          send: "Send my request",
          success: "Thank you, your request has been received.",
          successSubtitle: "Our partnerships team will get back to you within 5 days.",
          sendAnother: "Send another request",
          error: "Something went wrong. Please retry.",
        },
      },
    },
    donorPortal: {
      back: "Back to home",
      eyebrow: "Donor space",
      title: "Your commitment, your dashboard.",
      intro: "Enter your email to receive a secure sign-in link. You'll access your donation history and manage your monthly commitment.",
      welcome: "Welcome,",
      formTitle: "Receive a sign-in link",
      formSubtitle: "We'll send you a secure link valid for 30 minutes — no password needed.",
      emailPlaceholder: "your@email.com",
      sendLink: "Send my link",
      privacyNote: "For your security, we never reveal whether an address matches a donor account.",
      linkSent: "If the address is known, a link has just been sent.",
      linkSentTitle: "Check your inbox",
      linkSentText: "If this address matches a donation, you will find a secure link valid for 30 minutes.",
      tryAnother: "Use another address",
      error: "Something went wrong. Please retry.",
      connectedAs: "Signed in as",
      logout: "Sign out",
      kpis: {
        total: "Total given",
        count: "Donations made",
        activeSub: "Monthly commitment",
      },
      activeSubTitle: "You have an active monthly donation",
      activeSubText: "Thank you for your lasting commitment. You can cancel it any time, no justification needed.",
      cancelSub: "Cancel my monthly donation",
      confirmCancel: "Confirm cancellation of your monthly donation?",
      cancelled: "Monthly donation cancelled. Thank you for everything you have offered.",
      historyTitle: "Your donation history",
      empty: "No donations yet.",
      cols: {
        date: "Date",
        amount: "Amount",
        type: "Type",
        status: "Status",
        actions: "Receipt",
      },
      monthly: "Monthly",
      oneTime: "One-time",
      downloadReceipt: "Download receipt",
    },
    seo: {
      home: {
        title: "Fondation Cœur Solidaire — Widows & orphans, dignity restored",
        description: "International humanitarian foundation. Since 2014, we restore hope, dignity and a future to widows and orphans in 27 countries. Donate securely — 92% to field programs.",
      },
      campaigns: {
        title: "Our active fundraising campaigns",
        description: "Support a targeted campaign: back-to-school, Lebanon emergency, Roof & Future Mali. Each donation funds a precise, verified and audited objective.",
      },
      blog: {
        title: "News & field stories",
        description: "From the field: news, milestones and heartfelt updates from Fondation Cœur Solidaire. A transparent window on what your solidarity makes possible.",
      },
      impactMap: {
        title: "Our presence around the world",
        description: "27 countries, 47,000 widows and 112,000 orphans accompanied. Discover our programs country by country.",
      },
      board: {
        title: "Board of Directors",
        description: "A committed, experienced and 100% volunteer team that guarantees the rigor of every euro.",
      },
      testimonials: {
        title: "Voices of those we walk beside",
        description: "Discover the real stories of widows and orphans walking with Fondation Cœur Solidaire across 27 countries.",
      },
      legacy: {
        title: "Leave a legacy or lifetime gift",
        description: "Pass on a legacy of solidarity. Bequest, lifetime gift, in-kind donation — confidential notarial support.",
      },
      volunteer: {
        title: "Become a volunteer or partner",
        description: "Join the foundation. Volunteers, mentors, companies, NGOs: your commitment multiplies our field impact.",
      },
    },
    campaignsPage: {
      back: "Back to home",
      eyebrow: "Active campaigns",
      title: "Choose the cause that moves you.",
      intro: "Each campaign funds a concrete, verified objective on the field. Watch progress live, give in seconds.",
      loading: "Loading…",
      empty: "No active campaign. Come back very soon.",
      raised: "raised",
      of: "of",
      donors: "donors",
      deadline: "Ends",
      noDeadline: "Ongoing",
      progress: "Progress",
      support: "Support this campaign",
      moreDetails: "Learn more",
      completed: "Goal reached",
      remaining: "remaining",
      ctaTitle: "Another cause calls you?",
      ctaSubtitle: "Make an unrestricted donation — we will allocate it where the need is greatest.",
      ctaButton: "Donate freely",
      navLink: "Campaigns",
    },
    campaignDetail: {
      back: "All campaigns",
      raised: "raised",
      goal: "Goal",
      donors: "donors",
      deadline: "Deadline",
      noDeadline: "Ongoing",
      supportNow: "Support this campaign",
      shareTitle: "Share this campaign",
      shareTwitter: "Share on X",
      shareWhatsapp: "Share on WhatsApp",
      shareLinkedin: "Share on LinkedIn",
      shareCopy: "Copy link",
      copied: "Link copied",
      notFound: "This campaign cannot be found.",
      relatedTitle: "Other campaigns",
    },
    homeCampaigns: {
      eyebrow: "Active campaigns",
      title: "Support a precise cause.",
      subtitle: "Each campaign funds a concrete objective. Watch progress live.",
      viewAll: "View all campaigns",
      raised: "raised",
      of: "of",
      support: "Support",
    },
  },
};

function getImpact(amount, lang) {
  const tiers = {
    fr: [
      { min: 250, text: "un mois de loyer pour une veuve et ses enfants" },
      { min: 100, text: "trois mois de scolarité pour un orphelin" },
      { min: 50, text: "des soins médicaux essentiels pour une famille" },
      { min: 25, text: "une semaine de repas pour deux enfants" },
      { min: 0, text: "une aide essentielle à une famille" },
    ],
    en: [
      { min: 250, text: "one month of rent for a widow and her children" },
      { min: 100, text: "three months of school for an orphan" },
      { min: 50, text: "essential medical care for a family" },
      { min: 25, text: "a week of meals for two children" },
      { min: 0, text: "essential aid to a family" },
    ],
  };
  const list = tiers[lang] || tiers.fr;
  const found = list.find((t) => amount >= t.min);
  return found.text;
}
